import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';

export const styles = StyleSheet.create({
  container: {
    width: 600,
    alignSelf: 'center',
    rowGap: 8,
  },
  content: {
    padding: 30,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.white,
  },
  list: {
    maxHeight: 500,
  },
  rows: {
    rowGap: 8,
  },
  emptyContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 40,
    minHeight: 200,
  },
  emptyText: {
    fontSize: 16,
    color: theme.palette.mono600,
    textAlign: 'center',
    fontFamily: theme.fonts.regular,
  },
  errorContainer: {
    backgroundColor: theme.palette.redLightest,
    borderRadius: theme.radius.s,
    padding: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: theme.palette.red,
  },
  errorText: {
    fontSize: 14,
    color: theme.palette.red,
    textAlign: 'center',
    fontFamily: theme.fonts.medium,
    fontWeight: '600',
  },
});
